export default __webpack_public_path__ + "static/media/60.1f242179.svg";